import { z } from "zod";

export const ProductionCostLineTypeSchema = z.enum([
  "prop",
  "costume",
  "material",
  "service",
  "other",
]);
export type ProductionCostLineType = z.infer<typeof ProductionCostLineTypeSchema>;

export const ProductionCostStatusSchema = z.enum([
  "planned",
  "paid",
  "cancelled",
]);
export type ProductionCostStatus = z.infer<typeof ProductionCostStatusSchema>;

export const ProductionCostLineSchema = z.object({
  id: z.string(),
  eventId: z.string(),
  lineType: ProductionCostLineTypeSchema,
  description: z.string(),
  quantity: z.number().int().positive(),
  unit: z.string().nullable(),
  unitPrice: z.number().int().min(0),
  subtotal: z.number().int().min(0),
  vendorName: z.string().nullable(),
  status: ProductionCostStatusSchema,
  linkedPayoutId: z.string().nullable(),
  notes: z.string().nullable(),
  sortOrder: z.number().int(),
  paidBy: z.string().nullable(),
  paidAt: z.coerce.date().nullable(),
  createdBy: z.string().nullable(),
  createdAt: z.coerce.date(),
  updatedAt: z.coerce.date(),
});
export type ProductionCostLineDTO = z.infer<typeof ProductionCostLineSchema>;

export const ProductionCostSummarySchema = z.object({
  plannedTotal: z.number().int(),
  paidTotal: z.number().int(),
  lineCount: z.number().int(),
});
export type ProductionCostSummaryDTO = z.infer<typeof ProductionCostSummarySchema>;

export const ProductionCostListResponseSchema = z.object({
  items: z.array(ProductionCostLineSchema),
  summary: ProductionCostSummarySchema,
});
export type ProductionCostListResponseDTO = z.infer<
  typeof ProductionCostListResponseSchema
>;

export const CreateProductionCostLineSchema = z.object({
  lineType: ProductionCostLineTypeSchema.default("prop"),
  description: z.string().trim().min(1, "ຕ້ອງປ້ອນລາຍລະອຽດ"),
  quantity: z.number().int().positive("ຈຳນວນຕ້ອງຫຼາຍກວ່າ 0").default(1),
  unit: z.string().trim().nullable().optional(),
  unitPrice: z.number().int().min(0, "ລາຄາຕ້ອງ ≥ 0"),
  vendorName: z.string().trim().nullable().optional(),
  notes: z.string().trim().nullable().optional(),
  markPaid: z.boolean().optional().default(false),
});
export type CreateProductionCostLineDTO = z.infer<
  typeof CreateProductionCostLineSchema
>;

export const UpdateProductionCostLineSchema = z.object({
  lineType: ProductionCostLineTypeSchema.optional(),
  description: z.string().trim().min(1, "ຕ້ອງປ້ອນລາຍລະອຽດ").optional(),
  quantity: z.number().int().positive("ຈຳນວນຕ້ອງຫຼາຍກວ່າ 0").optional(),
  unit: z.string().trim().nullable().optional(),
  unitPrice: z.number().int().min(0, "ລາຄາຕ້ອງ ≥ 0").optional(),
  vendorName: z.string().trim().nullable().optional(),
  notes: z.string().trim().nullable().optional(),
});
export type UpdateProductionCostLineDTO = z.infer<
  typeof UpdateProductionCostLineSchema
>;

export const ProductionCostLineParamSchema = z.object({
  eventId: z.string().min(1),
  lineId: z.string().min(1),
});
